export function useAlgoliaSearchOptions(hostUrl?: string) {
  if (!hostUrl) return {}

  const headers = import.meta.server
    ? {
        headers: {
          'user-agent': 'bm-search-javascript-client',
        },
      }
    : {}

  return {
    hosts: [{ url: hostUrl as string, protocol: 'https' }],
    ...headers,
  }
}
